export default class DefaultException extends Error {
  // https://stackoverflow.com/a/32749533
  constructor(message) {
    super(message || ''); // so null message doesn't converted into 'null'
    this.name = this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}
